module.exports = __webpack_public_path__ + "img/bg.837e99ea.png";